import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";
export const apprReportTabCol=(filteredInfos)=>{
    let filteredInfo=changeFilteredInfo(filteredInfos)
    return [{
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
    }, {
        title: '系统',
        dataIndex: 'platform',
        key: 'platform',
        scopedSlots: {
            filterIcon: 'filterIcon',
            filterDropdown: 'filterDropdownPlatform',
            filtered: true,
            customRender: 'platform'
        },
        filteredValue: filteredInfo.platform || [],
    }, {
        title: '合同号',
        dataIndex: 'contractNo',
        key: 'contractNo',
        scopedSlots: {
            filterIcon: 'filterIcon',
            filterDropdown: 'filterDropdown',
            filtered: true,
            customRender: 'foldInfo'
        },
        filteredValue: filteredInfo.contractNo || [],
    }, {
        title: '交付类型',
        dataIndex: 'projectType',
        key: 'projectType',
        scopedSlots: {
            filterIcon: 'filterIcon',
            filterDropdown: 'filterDropdown',
            filtered: true,
            customRender: 'foldInfo'
        },
        filteredValue: filteredInfo.projectType || [],
    },
        {
        title: '销售',
        dataIndex: 'salesList',
        key: 'salesName',
        scopedSlots: {
            filterIcon: 'filterIcon',
            filterDropdown: 'filterDropdown',
            filtered: true,
            customRender: 'salesName'
        },
        filteredValue: filteredInfo.salesName || [],
    }, {
        title: '分析员',
        dataIndex: 'analyst.name',
        key: 'analystName',
        scopedSlots: {
            filterIcon: 'filterIcon',
            filterDropdown: 'filterDropdown',
            filtered: true,
        },
        filteredValue: filteredInfo.analystName || [],
    },
        {
            title: '交付样品数目',
            dataIndex: 'sampleNum',
            key: 'sampleNum',
            sortDirections: ["descend", "ascend", "descend"],
            toModule: ['ngs', 'amp', 'tgg','meta-pro', 'pure', 'pcr','igut'],
        },

        {
            title: '加急状态',
            dataIndex: 'urgent',
            key: 'urgent',
            scopedSlots: {
                customRender: 'urgentStatus'
            }
        }, {
            title: '是否纯分析项目',
            dataIndex: 'isPure',
            key: 'isPure',
            scopedSlots: {
                customRender: 'pureStatus'
            }
        },
        {
            title: '商务、项目系统信息',
            dataIndex: 'projectSystemInfos',
            key: 'projectSystemInfos',
            children: [
                {
                    title: '合同状态',
                    dataIndex: 'contractTypeInfo',
                    key: 'contractStatus',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_contractStatus'
                    },
                },
                {
                    title: '合同分类',
                    dataIndex: 'contractTypeInfo',
                    key: 'contractType',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_contractType'
                    },
                },
                {
                    title: '测序平台',
                    dataIndex: 'contractTypeInfo',
                    key: 'sequencingPlatform',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_sequencingPlatform',
                    },
                },
                {
                    title: '合同样品数目',
                    dataIndex: 'contractTypeInfo.contractSampleNum',
                    key: 'contractSampleNum',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_contractSampleNum',
                    },
                },
                {
                    title: '合同数据量',
                    dataIndex: 'contractTypeInfo.planAmountSet',
                    key: 'contractTypeInfo.planAmountSet',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_planAmountSet1'
                    },
                },
                {
                    title: '分析要求',
                    dataIndex: 'contractTypeInfo.analyzeRequirements',
                    key: 'contractTypeInfo.analyzeRequirements',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_analyzeRequirements'
                    },
                },
                {
                    title: '登记数据量',
                    dataIndex: 'planAmountSet',
                    key: 'planAmountSet',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_planAmountSet',
                    },
                },
                {
                    title: '样品数目',
                    dataIndex: 'projectSystemInfos',
                    key: 'projectSystemInfos_sampleNum',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_sampleNum',
                    },
                },
                {
                    title: '样品数据量',
                    dataIndex: 'projectSystemInfos',
                    width:100,
                    key: 'projectSystemInfos_dataStatus',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_dataEnoughStatus',
                    },
                },
                ]
        },
        {
            title: '发起时间',
            dataIndex: 'createTime',
            key: 'createTime',
        },
        {
            title: '备注',
            dataIndex: 'submitRemark',
            key: 'submitRemark',
            scopedSlots: {
                customRender: 'remark'
            }
        },
        {
            title: '审批状态',
            dataIndex: 'approvalStatus',
            key: 'approvalStatus',
            scopedSlots: {
                customRender: 'approvalStatus'
            }
        },
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 300,

        }
    ]
}
